module.exports = __webpack_public_path__ + "assets/img/open_all_child_item.e5ec13ef.png";